<!-- Global site tag (gtag.js) - Google Analytics -->
<app-script-loader
  async="true"
  src="{{ analyticsEmbeddedScriptSource }}"
></app-script-loader>
<app-script-loader
  scriptText="{{ analyticsEmbeddedScript }}"
></app-script-loader>
